import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { TableTitle } from './styles'

interface IPatientsTableHeadProps {
  activeTab: number
}

export const PatientsTableHead = ({
  activeTab,
}: IPatientsTableHeadProps): JSX.Element => {
  return (
    <tr>
      <TableTitle>
        <Typography
          variant='content3'
          inlineStyles={{
            width: '50px',
            height: '30px',
            wordBreak: 'break-all',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {activeTab === 0 ? 'Faltas' : 'Cancela-mentos'}
        </Typography>
      </TableTitle>
      <TableTitle>
        <Typography
          variant='content3'
          inlineStyles={{
            height: '30px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
        Nome/convênio
        </Typography>
      </TableTitle>
      <TableTitle>
        <Typography
          variant='content3'
          inlineStyles={{
            height: '30px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
        Reserva
        </Typography>
      </TableTitle>
      <TableTitle></TableTitle>
    </tr>
  )
}